var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94596 9.31502C1.42396 9.14102 1.41896 8.86002 1.95596 8.68102L21.044 2.32002C21.573 2.14402 21.876 2.44002 21.728 2.95802L16.274 22.044C16.124 22.573 15.819 22.591 15.595 22.089L12 14L18 6.00002L9.99996 12L1.94596 9.31502Z",
    fill: "currentColor"
  })));
};
export default SvgShareIcon;